import React, { useState } from 'react';
import { Box, Typography, Button, Chip, Divider } from '@mui/material';
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

const IOS_COPY_TEXT =
  'Встановіть мобільний додаток (iOS): https://apps.apple.com/ru/app/testflight/id899247664';

const MobileAppWidget: React.FC = () => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(IOS_COPY_TEXT);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Мобільний додаток
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <AppleIcon fontSize="small" />
            <Typography variant="subtitle2">iOS</Typography>
          </Box>
          <Button
            variant="outlined"
            size="small"
            startIcon={copied ? <CheckIcon /> : <ContentCopyIcon />}
            onClick={handleCopy}
            color={copied ? 'success' : 'primary'}
          >
            {copied ? 'Скопійовано' : 'Скопіювати інструкцію'}
          </Button>
        </Box>

        <Divider />

        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
            <AndroidIcon fontSize="small" />
            <Typography variant="subtitle2">Android</Typography>
            <Chip label="Незабаром" size="small" variant="outlined" />
          </Box>
          <Typography variant="body2" color="text.secondary">
            Версія для Android у розробці
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default MobileAppWidget;
